import { DossierOverviewTable } from '@/components';

export default {
  name: 'DossierOverview',
  components: {
    DossierOverviewTable,
  },
  props: {},
  data: () => ({

  }),
  computed: {},
  methods: {},
};
